import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { EventsService, VariablesService } from 'src/app/shared/services';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { RippleDirective } from 'src/app/shared/directives/ripple/ripple.directive';

@Component({
  selector: 'app-header-v2',
  imports: [
    NgOptimizedImage,
    RouterModule,
    MatIconModule,
    RippleDirective,
    ComponentLoader,
    SideNavComponent
  ],
  templateUrl: './header-v2.component.html',
  styleUrls: ['./header-v2.component.scss']
})
export class HeaderV2Component {
  private readonly events = inject(EventsService);
  readonly vars = inject(VariablesService);

  readonly userData = computed(() => this.vars.userData());
  readonly showLogin = signal(false);

  openLogin() {
    this.showLogin.set(true);
    this.events.sendSystemEvent({
      eventName: 'signin clicked',
      event_type: 'signin'
    });
  }

  closeLogin() {
    this.showLogin.set(false);
  }

  onProfileSidebarOpen() {
    this.vars.sidebarDrawerState.set(true);
    if (this.vars.isBrowser()) {
      document.body.style.overflowY = 'hidden';
    }
  }

  // goToAllFundraiser() {
  //   this.events.sendSystemEvent({
  //     eventName: 'click_on_contribute',
  //     info_1: 'header'
  //   });
  //   const abandonedCart = this.storage.get('abandonedCartOtd');
  //   if (abandonedCart?.link) {
  //     this.util.router.navigate([abandonedCart?.link], { queryParams: { donate: 1, payment: 'form' }, queryParamsHandling: 'merge'});
  //   } else {
  //     this.util.navigate('fundraisers');
  //   }
  // }
}
